<div>
  <!-- Categories Table -->
  <p-table
    #table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="categories()"
    [loading]="loading()"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="{first}-{last} of {totalRecords}"
    [stripedRows]="true"
  >
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex flex-col md:flex-row gap-3 md:gap-2">
        <div class="flex gap-2">
          <p-button
            label="{{ 'categories.addCategory' | translate }}"
            icon="pi pi-plus"
            severity="success"
            [disabled]="loading()"
            [loading]="loading()"
            (onClick)="openCreateDialog()"
          >
          </p-button>
        </div>
        <p-iconfield iconPosition="left" class="md:ml-auto w-full md:w-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            #searchInput
            pInputText
            type="text"
            [formControl]="searchControl"
            [placeholder]="'categories.searchPlaceholder' | translate"
            class="w-full"
          />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 200px">{{ 'categories.headers.label' | translate }}</th>
        <th style="min-width: 300px">{{ 'categories.headers.description' | translate }}</th>
        <th style="min-width: 150px">{{ 'categories.headers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-category>
      <tr>
        <td style="min-width: 200px">{{ category.label }}</td>
        <td style="min-width: 300px">{{ category.description || '-' }}</td>
        <td style="min-width: 150px" class="py-2">
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              size="small"
              [disabled]="loading()"
              [ariaLabel]="'categories.edit' | translate"
              (onClick)="openEditDialog(category)"
            >
            </p-button>
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              size="small"
              [disabled]="loading() || (category.projectCount ?? 0) > 0"
              [pTooltip]="getDeleteTooltip(category) || ''"
              [tooltipDisabled]="(category.projectCount ?? 0) === 0"
              [ariaLabel]="'categories.delete' | translate"
              (onClick)="deleteCategory(category)"
            >
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-tag text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'categories.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Create/Edit Dialog -->
  <p-dialog
    [header]="getDialogTitle()"
    [(visible)]="dialogVisible"
    [modal]="true"
    [style]="{ width: '500px' }"
    [draggable]="false"
    [resizable]="false"
  >
    <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()">
      <!-- Label Field -->
      <div class="mb-4">
        <label for="label" class="block mb-2">{{ 'categories.form.label' | translate }} *</label>
        <input
          id="label"
          type="text"
          pInputText
          formControlName="label"
          [class.ng-invalid]="isFieldInvalid('label')"
          [class.ng-dirty]="isFieldInvalid('label')"
          class="w-full"
          [placeholder]="'categories.form.labelPlaceholder' | translate"
        />
        @if (isFieldInvalid('label')) {
        <p-message severity="error">
          {{ getFieldError('label') }}
        </p-message>
        }
        <small class="block mt-1 text-muted">{{ 'categories.form.labelHint' | translate }}</small>
      </div>

      <!-- Description Field -->
      <div class="mb-4">
        <label for="description" class="block mb-2">
          {{ 'categories.form.description' | translate }}
        </label>
        <textarea
          id="description"
          formControlName="description"
          class="p-inputtext w-full"
          [placeholder]="'categories.form.descriptionPlaceholder' | translate"
          rows="3"
        ></textarea>
      </div>

      <!-- Dialog Footer -->
      <div class="flex justify-end gap-2 mt-6">
        <p-button
          label="{{ 'common.cancel' | translate }}"
          severity="secondary"
          (onClick)="dialogVisible.set(false)"
          [disabled]="loading()"
        >
        </p-button>
        <p-button
          label="{{ 'common.save' | translate }}"
          type="submit"
          [disabled]="loading() || categoryForm.invalid"
          [loading]="loading()"
        >
        </p-button>
      </div>
    </form>
  </p-dialog>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>
